import {Injectable} from '@angular/core';
import {CoreBaseEffects} from '@core/core-base.effects';
import {Store} from '@ngrx/store';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {Observable} from 'rxjs';
import {SharedChatActions} from '@shared/components/chat/store/shared-chat.actions-type';
import {ChatDto, ChatMessageListDto, ContactChatMemberDto, LocationChatMemberDto,} from '@server-models';
import {IPaginationParams} from '@shared/interfaces/pagination-params.interface';

@Injectable({
  providedIn: 'root',
})
export abstract class SharedChatEffectsBase extends CoreBaseEffects {
  protected constructor(store: Store, rawActions$: Actions) {
    super(store, rawActions$);
  }

  abstract initChat(action$: Observable<any>): Observable<any>;

  abstract initChatSuccess(action$: Observable<{ chat: ChatDto }>): Observable<any>;

  abstract getChat(action$: Observable<{ chatId: number }>): Observable<any>;

  abstract addChatMember(
    action$: Observable<{ chatId: number; member: LocationChatMemberDto | ContactChatMemberDto }>
  ): Observable<any>;

  abstract removeChatMember(
    action$: Observable<{ chatId: number; member: LocationChatMemberDto | ContactChatMemberDto }>
  ): Observable<any>;

  abstract addMe(action$: Observable<{ chatId: number }>): Observable<any>;

  abstract removeMe(action$: Observable<{ chatId: number }>): Observable<any>;

  abstract chatMessageSend(
    action$: Observable<{
      chatId: any;
      message: ChatMessageListDto;
    }>
  ): Observable<ChatMessageListDto | any>;

  abstract deleteChatMessage(action$: Observable<any>): Observable<any>;

  initChat$ = createEffect(() =>
    this.actions().pipe(ofType(SharedChatActions.initChat), (action) => this.initChat(action))
  );

  initChatSuccess$ = createEffect(() =>
    this.actions().pipe(ofType(SharedChatActions.initChatSuccess), (action) => this.initChatSuccess(action))
  );

  getChat$ = createEffect(() =>
    this.actions().pipe(ofType(SharedChatActions.getChat), (action) => this.getChat(action))
  );

  chatMessageSend$ = createEffect(() =>
    this.actions().pipe(ofType(SharedChatActions.chatMessageSend), (action) => this.chatMessageSend(action))
  );

  addChatMember$ = createEffect(() =>
    this.actions().pipe(ofType(SharedChatActions.addChatMember), (action) => this.addChatMember(action))
  );

  removeChatMember$ = createEffect(() =>
    this.actions().pipe(ofType(SharedChatActions.removeChatMember), (action) => this.removeChatMember(action))
  );

  addMe$ = createEffect(() => this.actions().pipe(ofType(SharedChatActions.addMe), (action) => this.addMe(action)));

  removeMe$ = createEffect(() =>
    this.actions().pipe(ofType(SharedChatActions.removeMe), (action) => this.removeMe(action))
  );

  deleteChatMessage$ = createEffect(() => this.actions().pipe(
    ofType(SharedChatActions.deleteChatMessage),
    action => this.deleteChatMessage(action)
  ))
}
